import { createStore } from 'vuex'
import axios from 'axios'

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

export default createStore({
  state: {
    content: undefined,
    profielen: [],
    match: {
      made: false,
      name: undefined
    },
    user: {
      name: 'Nicky',
      hobby: "zeilen",
      work: "het onderwijs"
    },
    login: false,
    credits: 3
  },
  mutations: {
    matchMade (state, obj) {
      let match = state.match;
      match.name = obj.name;
      match.avatar = obj.avatar;
      match.work = obj.werk;
      match.made = true;
    },

    login (state, obj) {
      let user = state.user;
      user.name = obj.name || user.name;
      user.hobby = obj.hobby || user.hobby;
      user.work = obj.work || user.work;
      state.login = true;
    },

    saveData(state, obj) {
      state.content = obj;
      state.profielen =  shuffle(obj.profielen);
    },

    creditsAdd(state, credits) {
      state.credits += credits;
    },

    creditsSubtract(state) {
      if(state.credits === 0) return;
      state.credits -= 1;
    }
  },
  actions: {
    matchMade ({ commit }, name) {
      commit('matchMade', name)
    },

    creditsAdd ({ commit }, credits) {
      commit('creditsAdd', credits)
    },

    creditsSubtract ({ commit }) {
      commit('creditsSubtract')
    }, 

    login ({ commit }, obj) {
      commit('login', obj)
    },

    loadData ({ commit }) {
      let str = "https://pointer-dev.kro-ncrv.nl/cms/site/assets/data/index.php?f=datingfraude_nepprofielen"
      return new Promise((resolve, reject) => { 
        axios
          .get(str)
          .then(result => {
            commit("saveData", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    


  },
  modules: {
  }
})
